import { api } from '../helpers';

export const getFaqs = (_, token) => api('/Faq', 'GET', null, null, token);
